module.exports = __webpack_public_path__ + "img/map-and-contact-white-mazda.0e02a212.png";